import Page from "./Page.vue";
import Vue from "vue";
import waitUntil from 'wait-until';
import Toasted from 'vue-toasted';
import delay from "delay";

common.View.create('galaxy::common.canvas.editor.canvas.document.Page', {

    async onDOMLoad()
    {
        await this.disableWebsiteInteraction();
        await this.waitForParentReady();

        this.initVue();
        this.initToasted();
    },

    async waitForParentReady()
    {
        return new Promise(resolve => {
            waitUntil(40, 1000000, () => !!window.canvasEditorIframeComponent, resolve);
        });
    },

    initVue()
    {
        // Init vue app.
        let that = this;

        // TODO Move to own .vue file?
        let vueApp = new Vue({
            el: '.vueApp',
            provide: function()
            {
                //
                let editorComponent = window.canvasEditorIframeComponent.editorComponent;

                //
                return {
                    layoutView: that,
                    editorComponent,
                    canvasComponent: editorComponent.canvasComponent,
                    $pageComponent: () => this.pageComponent
                };
            },

            data()
            {
                return {
                    pageComponent: null,

                    // Set from outside iframe.
                    scale: null,
                };
            }
        });

        // @ugly Init page. Fake its parent so we can se it in the vue developer tools.
        vueApp.pageComponent = new Page._Ctor[0]({
            parent: vueApp,
            propsData: {
                element: this.element,
            }
        });

        // Set app on iframe.
        window.canvasEditorIframeComponent.iframeApp = vueApp;
    },

    initToasted()
    {
        $(() => Vue.use(Toasted, {
            //theme: 'bootstrap',
            position: 'bottom-right',
            duration: 5 * 1000,
        }));
    },

    async disableWebsiteInteraction()
    {
        // Make 'sure' website JS onDomLoad's are processed first.
        await delay(1);

        // Abort navigating. This also works on elements which are added later. But we did not unregister clicks.
        $('body').on('click', 'a', event =>
        {
            event.preventDefault();

            return false;
        });
    },

});
